export default "__VITE_ASSET__YeXsqZVj__"